import { AsyncValidatorFn, FormGroup } from '@angular/forms';
import { ValidatorOrOptions } from './abstract-input';
import { BaseInput } from './base-input';

export interface InputContainerConstructor {
    /**
     * Configuration options for the form controls.
     * An object where the keys represent the control names and the values represent the corresponding input components.
     *
     */
    controls: {
        [key: string]: BaseInput<any>;
    };

    /**
     * Validator or validation options for the form.
     *
     */
    validatorOrOpts?: ValidatorOrOptions;

    /**
     * Asynchronous validator function or an array of asynchronous validator functions for the form.
     *
     */
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null;
}

export class InputContainer<T> extends FormGroup {
    /**
     * The controls of the form.
     *
     */
    override controls!: {
        [key: string]: BaseInput<any>;
    };

    constructor(options: InputContainerConstructor) {
        super(options.controls, options.validatorOrOpts, options.asyncValidator);
    }
}
